var exports = {
  "kL": "FriendSelector.module__container___bklxNz",
  "hJ": "FriendSelector.module__searchField___bklxNz",
  "lA": "FriendSelector.module__searchFieldInner___bklxNz",
  "t$": "FriendSelector.module__selectedPill___bklxNz",
  "DT": "FriendSelector.module__removeButton___bklxNz",
  "qc": "FriendSelector.module__searchIcon___bklxNz",
  "D3": "FriendSelector.module__searchIconFocused___bklxNz",
  "Rt": "FriendSelector.module__searchInput___bklxNz",
  "XG": "FriendSelector.module__scroller___bklxNz",
  "yY": "FriendSelector.module__scrollerNoSearch___bklxNz",
  "p$": "FriendSelector.module__emptyState___bklxNz",
  "q6": "FriendSelector.module__emptyStateText___bklxNz",
  "_s": "FriendSelector.module__groupsContainer___bklxNz",
  "cp": "FriendSelector.module__groupLetter___bklxNz",
  "QS": "FriendSelector.module__friendsList___bklxNz",
  "jZ": "FriendSelector.module__friendButton___bklxNz",
  "An": "FriendSelector.module__friendButtonSelected___bklxNz",
  "FI": "FriendSelector.module__friendButtonDisabled___bklxNz",
  "Hb": "FriendSelector.module__friendInfo___bklxNz",
  "G3": "FriendSelector.module__friendName___bklxNz",
  "HI": "FriendSelector.module__checkboxContainer___bklxNz",
  "Yz": "FriendSelector.module__removeIcon___bklxNz",
};

module.exports = exports;
